export default __webpack_public_path__ + "static/media/digital_marketing.d93e4a52.svg";